export const FILLING_ACTION_PLACEMENTS = {
  menu: 'menu',
  mainScreen: 'mainScreen',
};

export const normalizeFillingActionPlacement = (placement) => {
  if (placement === FILLING_ACTION_PLACEMENTS.mainScreen) {
    return FILLING_ACTION_PLACEMENTS.mainScreen;
  }

  return FILLING_ACTION_PLACEMENTS.menu;
};

export const getFillingActionPlacement = (mappingConfig) => normalizeFillingActionPlacement(
  mappingConfig?.columns?.filling?.operationActionPlacement,
);

export const shouldShowFillingActionInMainScreen = (mappingConfig) => (
  getFillingActionPlacement(mappingConfig) === FILLING_ACTION_PLACEMENTS.mainScreen
);
